export const FeatureName: string = 'common';
